export const COLOR_WHITE = '#ffffff'
export const COLOR_BLACK = '#000000'
export const COLOR_GREY = '#d3d3d3'
export const COLOR_BLUE = '#3498db'
export const COLOR_GREEN = '#07bc0c'
export const COLOR_RED = '#e74c3c'
export const COLOR_YELLOW = '#f1c40f'

export const TOAST_TYPE_COLORS = {
  default: COLOR_WHITE,
  info: COLOR_BLUE,
  success: COLOR_GREEN,
  danger: COLOR_RED,
  warning: COLOR_YELLOW,
}

export const FONT_COLORS = {
  default: COLOR_BLACK,
  info: COLOR_WHITE,
  success: COLOR_WHITE,
  danger: COLOR_WHITE,
  warning: COLOR_BLACK,
}

export const ICON_COLORS = {
  default: COLOR_GREY,
  info: COLOR_WHITE,
  success: COLOR_WHITE,
  danger: COLOR_WHITE,
  warning: COLOR_WHITE,
}
